import { useState, useEffect } from 'react';

export const useScheduledTasks = (socket, user) => {
  const [scheduledTasks, setScheduledTasks] = useState([]);
  const [scheduledTaskUpdates, setScheduledTaskUpdates] = useState(null);

  useEffect(() => {
    if (!socket) return;

    const handleOfferApproved = (data) => {
      console.log('✅ ===== OFFER APPROVED =====');
      console.log('📋 Approved Offer Data:', JSON.stringify(data, null, 2));

      const { taskId, offerId } = data;

      setScheduledTasks((prev) => {
        const existingIndex = prev.findIndex(
          (task) => task.taskId === taskId || task.offerId === offerId
        );

        if (existingIndex !== -1) {
          const updated = [...prev];
          updated[existingIndex] = {
            ...updated[existingIndex],
            ...data,
            status: 'scheduled',
            updatedAt: new Date(),
          };
          return updated;
        }

        return [...prev, { ...data, status: 'scheduled', receivedAt: new Date() }];
      });

      setScheduledTaskUpdates({ type: 'approved', data, timestamp: new Date() });
    };

    const handleOfferRejected = (data) => {
      console.log('❌ ===== OFFER REJECTED =====');
      console.log('📋 Rejected Offer Data:', JSON.stringify(data, null, 2));

      const { taskId, offerId } = data;

      setScheduledTasks((prev) =>
        prev.filter((task) => task.taskId !== taskId && task.offerId !== offerId)
      );

      setScheduledTaskUpdates({ type: 'rejected', data, timestamp: new Date() });
    };

    const handleTaskScheduled = (data) => {
      console.log('📅 ===== NEW TASK SCHEDULED =====');
      console.log('📋 Scheduled Task Data:', JSON.stringify(data, null, 2));

      setScheduledTasks((prev) => {
        const exists = prev.find((task) => task.taskId === data.taskId);
        if (exists) return prev;
        return [...prev, { ...data, receivedAt: new Date() }];
      });

      setScheduledTaskUpdates({ type: 'scheduled', data, timestamp: new Date() });
    };

    const handleTaskUpdated = (data) => {
      console.log('🔄 ===== TASK UPDATED =====');
      console.log('📋 Updated Task Data:', JSON.stringify(data, null, 2));

      const { taskId } = data;

      setScheduledTasks((prev) =>
        prev.map((task) =>
          task.taskId === taskId
            ? { ...task, ...data, updatedAt: new Date() }
            : task
        )
      );

      setScheduledTaskUpdates({ type: 'updated', data, timestamp: new Date() });
    };

    const handleTaskCancelled = (data) => {
      console.log('🚫 ===== TASK CANCELLED =====');
      console.log('📋 Cancelled Task Data:', JSON.stringify(data, null, 2));

      const { taskId } = data;

      setScheduledTasks((prev) => prev.filter((task) => task.taskId !== taskId));

      setScheduledTaskUpdates({ type: 'cancelled', data, timestamp: new Date() });
    };

    socket.on('offer:approved', handleOfferApproved);
    socket.on('offer:rejected', handleOfferRejected);
    socket.on('task:scheduled', handleTaskScheduled);
    socket.on('task:updated', handleTaskUpdated);
    socket.on('task:cancelled', handleTaskCancelled);

    return () => {
      socket.off('offer:approved', handleOfferApproved);
      socket.off('offer:rejected', handleOfferRejected);
      socket.off('task:scheduled', handleTaskScheduled);
      socket.off('task:updated', handleTaskUpdated);
      socket.off('task:cancelled', handleTaskCancelled);
    };
  }, [socket]);

  return {
    scheduledTasks,
    setScheduledTasks,
    scheduledTaskUpdates,
    setScheduledTaskUpdates,
  };
};
